import { InteractionHandler } from "../Interactions";
import { convertToNumber3, convertToNumber4, EnableModelTransformHandlesAction, UpdateGizmoMessage, SwitchTransformModeAction, UpdateGizmoModeMessage } from "flavr-common";
export class ModelTransformInteractionHandler extends InteractionHandler {
    constructor(interactionModule) {
        super("ModelTransformInteractionHandler", [], [EnableModelTransformHandlesAction.typestatic, SwitchTransformModeAction.typestatic], []);
        this.interactionModule = interactionModule;
        this.handleModelDeselected = () => {
            if (this._selectedModelUid !== undefined) {
                const modelUid = this._selectedModelUid;
                this.connection.send(new UpdateGizmoMessage(modelUid, false));
            }
            this._selectedModelUid = undefined;
        };
        this._selectedModelUid = undefined;
        interactionModule.onSelectNothingHit.add(this.handleModelDeselected);
    }
    performAction(params, context) {
        if (context.targetUid === undefined)
            return;
        if (EnableModelTransformHandlesAction.is(params)) {
            this.handleModelSelected(context.targetUid, params.scalable);
        }
        else if (SwitchTransformModeAction.is(params)) {
            const messages = [];
            const selectedModelUID = this._selectedModelUid;
            if (selectedModelUID === undefined)
                return;
            switch (params.mode) {
                case "translate":
                    messages.push(new UpdateGizmoModeMessage(selectedModelUID, 0));
                    break;
                case "rotate":
                    messages.push(new UpdateGizmoModeMessage(selectedModelUID, 1));
                    break;
                case "scale":
                    messages.push(new UpdateGizmoModeMessage(selectedModelUID, 2));
                    break;
                case "reset":
                    messages.push(new UpdateGizmoModeMessage(selectedModelUID, 3));
                    break;
                case "world":
                    messages.push(new UpdateGizmoModeMessage(selectedModelUID, -1, true));
                    break;
                case "local":
                    messages.push(new UpdateGizmoModeMessage(selectedModelUID, -1, false));
                    break;
            }
            this.connection.sendMultiple(messages);
        }
    }
    handleModelSelected(modelUid, scalable) {
        this._selectedModelUid = modelUid;
        const modelTrans = this.interactionModule.getModelTransformation(this._selectedModelUid);
        if (modelTrans === undefined)
            return;
        this.connection.send(new UpdateGizmoMessage(this._selectedModelUid, true, convertToNumber3(modelTrans.pos), convertToNumber4(modelTrans.ori), convertToNumber3(modelTrans.scale), scalable));
    }
}
